<template>
    <div class="search-container">
        <div
            v-if="regionModel.loading"
            class="loading"
        >
            {{ loadingMessage }}
        </div>
        <template v-else>
            <div
                v-if="$screens.mobile"
                class="mobile-hint"
            >
                Search postal code or community:
            </div>
            <autocomplete
                class="autocomplete"
                :get-autocomplete-items="str => searchForRegion(str)"
                :placeholder="placeholder"
                @submit="selectRegion"
                @input="() => regionModel.clearSearchError()"
            />
            <div
                v-if="regionModel.searchError"
                class="search-error"
            >
                {{ regionModel.searchError }}
            </div>
        </template>
    </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete.vue';
import RegionModel from '@/model/RegionModel';

export default {
    components: {
        Autocomplete
    },
    props: {
        regionModel: {
            type: RegionModel,
            required: true
        },
        placeholder: {
            type: String,
            default: 'postal code or community...'
        }
    },
    computed: {
        loadingMessage() {
            return this.regionModel.loadingMessage;
        }
    },
    methods: {
        searchForRegion(value) {
            if (value.length < 3) {
                return [];
            }
            return this.regionModel.searchForRegion(value);
        },
        selectRegion(value) {
            this.regionModel.selectRegion(value);
        }
    }
};
</script>

<style lang="postcss" scoped>
.loading {
    @apply mx-auto;
    text-align: center;
}

.mobile-hint, .loading {
    @apply text-neutral-info;
}

.search-error {
    @apply
        text-red-400
        text-xs
}
.search-container {
    @apply border-b border-neutral-5 flex flex-col justify-center flex-grow-0;
    height: 75px;
}

@screen mobile {
    .search-container {
        @apply block mr-8 ml-2;
        height: 100%;
        font-size: 14px;
        padding-top: 20px;
    }
}
</style>
<style lang="postcss">
@screen mobile {
    .search-container input {
        @apply border border-neutral-input rounded-full inline-block h-6;
    }
    .search-container .search-icon {
        @apply pr-5;
    }
    .search-container  .autocomplete-content {
        @apply w-full;
        max-height: calc(85vh - 75px);
    }
    input:not(:focus) ~ .autocomplete-content:not(:hover) {
        opacity: unset !important;
        pointer-events: unset !important;
    }
}
</style>
